module.exports = __webpack_public_path__ + "static/media/web-phone-primary-logo.6f320e31.svg";